export interface SalesOrderDepositReportLine {
  amount: number;
  notes: string;
  dateEntered: Date;
  currencySymbol: string;
  paid: string;
  datePaid: Date;
}
